import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type AssetStatus = "active" | "inactive" | "removed";

interface Props {
  status: AssetStatus;
  className?: string;
}

const LABEL: Record<AssetStatus, string> = {
  active: "Active",
  inactive: "Inactive",
  removed: "Removed",
};

const STYLE: Record<AssetStatus, string> = {
  active: "bg-green-100 text-green-800 border-green-200",
  inactive: "bg-gray-100 text-gray-600 border-gray-200",
  removed: "bg-red-100 text-red-800 border-red-200",
};

export function AssetStatusBadge({ status, className }: Props) {
  return (
    <Badge
      variant="outline"
      className={cn("rounded-full px-2.5 py-0.5 font-medium", STYLE[status], className)}
      data-testid={`asset-status-${status}`}
    >
      {LABEL[status]}
    </Badge>
  );
}

/**
 * Pick the right badge state from an asset's lifecycle stamp + whether its
 * parent term is still live (current or upcoming — see
 * `policyIsCurrentOrUpcoming`). Removed always wins; otherwise an asset is
 * Active unless its term has ended.
 */
export function statusForAsset(
  removedAt: string | null | undefined,
  policyActive: boolean,
): AssetStatus {
  if (removedAt) return "removed";
  return policyActive ? "active" : "inactive";
}
